import { RootState } from '../store';
import { ServiceAccountState } from './serviceAccount.reducer';

export const getServiceAccount = (state: RootState): ServiceAccountState =>
  state.serviceAccount;

export const getBrandId = (state: RootState): number | undefined =>
  getServiceAccount(state)?.brandId;
